module.exports = __webpack_public_path__ + "static/media/Slide_2.c12a5a99.png";